import React, { useEffect, useState } from 'react'
import { FaSearch } from 'react-icons/fa'

import { useDebounce } from '../../hooks/useDebounce.ts'
import { useUserAssignmentCode } from '../../hooks/useUserAssignmentCode.ts'
import Card from '../common/Card/Card.tsx'
import Input from '../common/forms/Input/Input.tsx'
import SelectInputs, {
  MultiOption
} from '../common/forms/selectInputs/SelectInputs.tsx'

const getFieldByValue = (
  value: string,
  multiOptions: MultiOption[]
): string | undefined => {
  const option = multiOptions.find((opt) => opt.value === value)
  return option?.field
}

const FilterSection = ({
  setFilterParams,
  userAssignmentCode
}: {
  setFilterParams: React.Dispatch<React.SetStateAction<string | undefined>>
  userAssignmentCode?: string
}) => {
  const { options } = useUserAssignmentCode()
  const [search, setSearch] = useState<string>('')
  const [multiOptionsCode, setMultiOptionsCode] = useState<
    MultiOption[] | null
  >(null)

  const [selectedInputsCode, setSelectedInputsCode] = useState<string[] | null>(
    []
  )

  const debounceSearch = useDebounce(search, 400)

  useEffect(() => {
    setMultiOptionsCode(options)
  }, [options])

  useEffect(() => {
    if (multiOptionsCode && selectedInputsCode !== null) {
      const searchParams = debounceSearch
        ? `search=${debounceSearch}`
        : undefined

      let params = ''

      if (!userAssignmentCode) {
        selectedInputsCode.map((item, index) => {
          const field = getFieldByValue(item, multiOptionsCode as MultiOption[])
          params =
            params +
            `${index === 0 ? '&user_assignment_code=' : ''}${field}${index === selectedInputsCode.length - 1 ? '' : ','}`
        })
      } else {
        params = `&user_assignment_code=${userAssignmentCode}`
      }

      params =
        params !== undefined
          ? params + (searchParams ? `&${searchParams}` : '')
          : searchParams
            ? `?${searchParams}`
            : ''

      setFilterParams(params)
    }
  }, [debounceSearch, selectedInputsCode, multiOptionsCode, selectedInputsCode])

  return (
    <Card>
      <Card.Title>Filtrowanie</Card.Title>
      <Card.Body>
        <div className="grid lg:grid-cols-3 gap-4">
          <div>
            <Input
              id="phrase"
              name="phrase"
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Fraza"
              icon={<FaSearch />}
            />
          </div>

          {userAssignmentCode === undefined &&
            multiOptionsCode &&
            selectedInputsCode && (
              <div>
                <SelectInputs
                  label={'Filtruj wg przypisanego kodu'}
                  startWhenEmptyValue={'Wybierz kod'}
                  multiOptions={multiOptionsCode}
                  defaultSelected={[]}
                  selectedInputsValues={selectedInputsCode}
                  setSelectedInputsValues={
                    setSelectedInputsCode as React.Dispatch<
                      React.SetStateAction<string[]>
                    >
                  }
                />
              </div>
            )}
        </div>
      </Card.Body>
    </Card>
  )
}

export default React.memo(FilterSection)
